module.exports = __webpack_public_path__ + "static/img/wpp3_3.ca164de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/wpp3_3.png
// module id = h2Pl
// module chunks = 2